import { render, staticRenderFns } from "./ClientPortalSettings.vue?vue&type=template&id=8c817040&scoped=true&"
import script from "./ClientPortalSettings.vue?vue&type=script&lang=ts&"
export * from "./ClientPortalSettings.vue?vue&type=script&lang=ts&"
import style0 from "./ClientPortalSettings.vue?vue&type=style&index=0&id=8c817040&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c817040",
  null
  
)

export default component.exports